import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { CareCommentContent } from "../../../../domain/care_comment/CareCommentContent";
import { CareCommentTitle } from "../../../../domain/care_comment/CareCommentTitle";
import { State, useAppDispatch } from "../../../../state/store";
import { registerCareCommentAction } from "../../../../state/usecase/admin/care_comment/actions";
import { disableAlertAction, getCareRecipientInfoAction } from "../../../../state/usecase/admin/care_recipient/actions";
import { useAlertFromQueryParams } from "../../../hooks/admin/care_recipient/useAlertFromQueryParams";
import { useCareRecipientInformation } from "../../../hooks/admin/care_recipient/useCareRecipientInformation";
import { useCareRecipientIdFromPath } from "../../../hooks/care_recipient/useCareRecipientIdFromPath";
import { useInput } from "../../../hooks/common/useInput";
import { BackButton } from "../../common/button/BackButton";
import { Button } from "../../common/button/Button";
import { FullScreenLoading } from "../../common/FullScreenLoading";
import { InputTextArea } from "../../common/input/InputTexArea";
import { InputTextBox } from "../../common/input/InputTextBox";
import { Loading } from "../../common/Loading";

export function AdminCareCommentAddPage() {
    const alertMessage = useAlertFromQueryParams();

    const dispatch = useAppDispatch();

    const careRecipientId = useCareRecipientIdFromPath();

    const careRecipientInfo = useCareRecipientInformation();

    const initializeProcessing = !!useSelector((state: State) => state.adminCareRecipient.processing);

    const registerProcessing = !!useSelector((state: State) => state.adminCareComment.processing);

    useEffect(() => {
        if (!careRecipientId) return;
        dispatch(getCareRecipientInfoAction(careRecipientId));
    }, [dispatch, careRecipientId]);

    const [careCommentTitle, , handleCareCommentTitleChanged] = useInput("");

    const [careCommentContent, , handleCareCommentContentChanged] = useInput("");

    const handleRegisterClicked = () => {
        const invalidMessage: string[] = [];

        // タイトルの長さチェック
        if (CareCommentTitle.isInvalidSize(careCommentTitle)) {
            invalidMessage.push(CareCommentTitle.messageInvalidSize("タイトル"));
        }

        // 内容の長さチェック
        if (CareCommentContent.isInvalidSize(careCommentContent)) {
            invalidMessage.push(CareCommentContent.messageInvalidSize("ケアコメント内容"));
        }

        // エラーがある場合登録リクエストしない
        if (invalidMessage.length) {
            alert(invalidMessage.join("\n"));
            return;
        }

        dispatch(
            registerCareCommentAction({
                requestData: {
                    careRecipientId: careRecipientInfo?.careRecipient.id!,
                    title: CareCommentTitle.fromString(careCommentTitle),
                    content: CareCommentContent.fromString(careCommentContent)
                }
            })
        );

        if (alertMessage) {
            dispatch(
                disableAlertAction({ alertId: alertMessage.id })
            );
        }
    };

    if (!careRecipientInfo || initializeProcessing ) return <Loading />;

    return (
        <>
            {registerProcessing && <FullScreenLoading />}
            <div className={"care_comment_add_page"}>
                <div className={"container"}>
                    {/* 戻るボタン */}
                    <BackButton />
                    {/* 利用者情報 */}
                    <div className={"care_recipient_info"}>
                        利用者情報：
                        <div>{careRecipientInfo?.careRecipient.houseId?.value}</div>
                        <div>{careRecipientInfo?.careRecipient.name.value}</div>
                        <div>高齢者分類：{careRecipientInfo?.classification?.value ?? "未設定"}</div>
                    </div>
                    {/* アラート内容 */}
                    {alertMessage && (
                        <div className={"alert_info"}>
                            アラート内容：
                            <div>{alertMessage.date}</div>
                            <div>{alertMessage.category}</div>
                            <div>{alertMessage.message}</div>
                        </div>
                    )}
                    {/* コメント入力 */}
                    <div className={"care_comment_edit"}>
                        {/* 入力 */}
                        <div className={"content"}>
                            {/* タイトル */}
                            <div className={"body"}>
                                <div className={"label"}>タイトル</div>
                                <InputTextBox value={careCommentTitle} handleTextChanged={handleCareCommentTitleChanged} />
                            </div>
                            {/* 内容 */}
                            <div className={"body"}>
                                <div className={"label"}>内容</div>
                                <InputTextArea value={careCommentContent} handleTextChanged={handleCareCommentContentChanged} />
                            </div>
                        </div>
                        {/* ボタン */}
                        <Button label={"登録"} onClick={handleRegisterClicked} />
                    </div>
                </div>
            </div>
        </>
    );
}